/**
 * Talie — Main JS entry point.
 *
 * Core modules load unconditionally.
 * Feature modules load conditionally based on DOM presence.
 */

import '../css/main.scss';

import Navigation      from './modules/Navigation';
import BackToTop       from './modules/BackToTop';
import PageTransition  from './modules/PageTransition';
import LinkPrefetch    from './modules/LinkPrefetch';

// Core — always init.
new Navigation();
new BackToTop();
new PageTransition();
new LinkPrefetch();

// Set --header-height so hero can be exactly 100dvh - header.
const syncHeaderHeight = () => {
	const h = document.querySelector( '.js-header' );
	if ( h ) document.documentElement.style.setProperty( '--header-height', h.offsetHeight + 'px' );
};
syncHeaderHeight();
window.addEventListener( 'resize', syncHeaderHeight, { passive: true } );

// Feature — HeroGallery (Phase 4).
if ( document.querySelector( '.js-hero-gallery' ) ) {
	import( './modules/HeroGallery' ).then( ( { default: HeroGallery } ) => {
		document.querySelectorAll( '.js-hero-gallery' ).forEach( ( el ) => new HeroGallery( el ) );
	} );
}

// Feature — PortfolioVideoPlayer (Phase 5).
if ( document.querySelector( '.js-portfolio-block' ) ) {
	import( './modules/PortfolioVideoPlayer' ).then( ( { default: PortfolioVideoPlayer } ) => {
		document.querySelectorAll( '.js-portfolio-block' ).forEach( ( el ) => new PortfolioVideoPlayer( el ) );
	} );
}

// Feature — Lightbox (Phase 5).
if ( document.querySelector( '.js-lightbox' ) ) {
	import( './modules/Lightbox' ).then( ( { default: Lightbox } ) => {
		new Lightbox( document.querySelectorAll( '.js-lightbox' ) );
	} );
}

// Feature — GravityFormExpand (Phase 2).
if ( document.querySelector( '.js-expand-textarea' ) ) {
	import( './modules/GravityFormExpand' ).then( ( { default: GravityFormExpand } ) => {
		document.querySelectorAll( '.js-expand-textarea' ).forEach( ( el ) => new GravityFormExpand( el ) );
	} );
}

// Feature — TextGalleryFade: fibonacci gallery crossfade in text blocks.
if ( document.querySelector( '.js-text-gallery' ) ) {
	import( './modules/TextGalleryFade' ).then( ( { default: TextGalleryFade } ) => {
		document.querySelectorAll( '.js-text-gallery' ).forEach( ( el ) => new TextGalleryFade( el ) );
	} );
}

// Feature — PhotoFilter: gallery block + photos page category filter.
if ( document.querySelector( '.js-photo-filter' ) ) {
	import( './modules/PhotoFilter' ).then( ( { default: PhotoFilter } ) => {
		document.querySelectorAll( '.js-photo-filter' ).forEach( ( el ) => new PhotoFilter( el ) );
	} );
}

// Feature — WorkFilter: film archive category filter.
if ( document.querySelector( '.js-work-filter' ) ) {
	import( './modules/WorkFilter' ).then( ( { default: WorkFilter } ) => {
		document.querySelectorAll( '.js-work-filter' ).forEach( ( el ) => new WorkFilter( el ) );
	} );
}

// Feature — SingleVideoPlayer: facade video player on single portfolio pages.
if ( document.querySelector( '.js-single-video' ) ) {
	import( './modules/SingleVideoPlayer' ).then( ( { default: SingleVideoPlayer } ) => {
		document.querySelectorAll( '.js-single-video' ).forEach( ( el ) => new SingleVideoPlayer( el ) );
	} );
}

// Feature — HeroVideo: fade-in background iframe once the embed has loaded.
if ( document.querySelector( '.portfolio-hero__video' ) ) {
	import( './modules/HeroVideo' ).then( ( { default: HeroVideo } ) => {
		document.querySelectorAll( '.portfolio-hero__video' ).forEach( ( el ) => new HeroVideo( el ) );
	} );
}

// Feature — Testimonials slider (only when more than one testimonial).
if ( document.querySelector( '.testimonials--slider' ) ) {
	import( './modules/Testimonials' ).then( ( { default: Testimonials } ) => {
		document.querySelectorAll( '.testimonials--slider' ).forEach( ( el ) => new Testimonials( el ) );
	} );
}
